import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { RoleEnum } from '../../models';

const STORAGE_KEYS = {
  ACCESS_TOKEN: 'ACCESS_TOKEN',
  ID_TOKEN: 'ID_TOKEN',
  USER_ROLE: 'USER_ROLE',
  USER_ID: 'USER_ID',
  USER_DETAILS: 'USER_DETAILS',
  EXPIRES_AT: 'EXPIRES_AT',
  ACCESS_MODULE: 'ACCESS_MODULE',
  ACCESS_LIST: 'ACCESS_LIST',
  IPEP_ACCESS_TOKEN: 'IPEP_ACCESS_TOKEN'
};

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  // Manage auth access_token
  setAccessToken(accessToken: string): void {
    localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, accessToken);
  }

  getAccessToken(): string | null{
    return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
  }

  setIpepAccessToken(accessToken: string): void {
    localStorage.setItem(STORAGE_KEYS.IPEP_ACCESS_TOKEN, accessToken);
  }

  getIpepAccessToken(): string | null{
    return localStorage.getItem(STORAGE_KEYS.IPEP_ACCESS_TOKEN);
  }

  // Manage auth role
  setUserRole(role: RoleEnum): void {
    localStorage.setItem(STORAGE_KEYS.USER_ROLE, role);
  }

  getUserRole(): string | null {
    return localStorage.getItem(STORAGE_KEYS.USER_ROLE);
  }

  setAccessModule(module: string): void {
    localStorage.setItem(STORAGE_KEYS.ACCESS_MODULE, module);
  }

  getAccessModule(): string | null {
    return localStorage.getItem(STORAGE_KEYS.ACCESS_MODULE);
  }

  setAccessList(access:string): void{
    localStorage.setItem(STORAGE_KEYS.ACCESS_LIST,JSON.stringify(access))
  }

  getAccessList():string | null {
    return localStorage.getItem(STORAGE_KEYS.ACCESS_LIST);
  }

  // Manage user ID
  setUserId(userId: string): void {
    localStorage.setItem(STORAGE_KEYS.USER_ID, userId);
  }

  getUserId(): string | null {
    return localStorage.getItem(STORAGE_KEYS.USER_ID);
  }

  setUserDetails(userDetails: any): void {
    localStorage.setItem(STORAGE_KEYS.USER_DETAILS, JSON.stringify(userDetails));
  }

  getUserDetails(): any | null {
    const userDetails = localStorage.getItem(STORAGE_KEYS.USER_DETAILS);
    if(userDetails) {
      return JSON.parse(userDetails);
    }
    return userDetails;
  }

  // Manage auth id_token
  setIdToken(idToken: string): void {
    localStorage.setItem(STORAGE_KEYS.ID_TOKEN, idToken);
  }

  getIdToken(): string | null {
    return localStorage.getItem(STORAGE_KEYS.ID_TOKEN);
  }

  // Manage auth expires_at
  setExpiresAt(expiresAt: string): void {
    localStorage.setItem(STORAGE_KEYS.EXPIRES_AT, expiresAt);
  }

  getExpiresAt(): string | null {
    return localStorage.getItem(STORAGE_KEYS.EXPIRES_AT);
  }

  // Clear entire localStorage
  clear(): void {
    localStorage.clear();
  }

  //Generic Methods
  setItem(key : string, value : any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getItem(key : string) {
    const val = localStorage.getItem(key) ;
    return val ? JSON.parse(val) : "";
  }
 
}
